import * as i0 from '@angular/core';
import * as i1 from './modal.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/router';
import * as i4 from './modal.component';
import * as i5 from './modal-content.component';
import * as i6 from './modal-backdrop.component';
import * as i7 from './modal-window.component';
export const ModalModuleNgFactory:i0.NgModuleFactory<i1.ModalModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.RouterOutlet = (<any>(null as any));
var _decl0_12:i3.RouterLink = (<any>(null as any));
var _decl0_13:i3.RouterLinkWithHref = (<any>(null as any));
var _decl0_14:i3.RouterLinkActive = (<any>(null as any));
var _decl0_15:i3.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_16:i4.ModalComponent = (<any>(null as any));
var _decl0_17:i5.ModalContentComponent = (<any>(null as any));
var _decl0_18:i6.ModalBackdropComponent = (<any>(null as any));
var _decl0_19:i7.ModalWindowComponent = (<any>(null as any));
var _decl0_20:i2.AsyncPipe = (<any>(null as any));
var _decl0_21:i2.UpperCasePipe = (<any>(null as any));
var _decl0_22:i2.LowerCasePipe = (<any>(null as any));
var _decl0_23:i2.JsonPipe = (<any>(null as any));
var _decl0_24:i2.SlicePipe = (<any>(null as any));
var _decl0_25:i2.DecimalPipe = (<any>(null as any));
var _decl0_26:i2.PercentPipe = (<any>(null as any));
var _decl0_27:i2.TitleCasePipe = (<any>(null as any));
var _decl0_28:i2.CurrencyPipe = (<any>(null as any));
var _decl0_29:i2.DatePipe = (<any>(null as any));
var _decl0_30:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_31:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_32:i2.KeyValuePipe = (<any>(null as any));
var _decl0_33:i2.CommonModule = (<any>(null as any));
var _decl0_34:i3.RouterModule = (<any>(null as any));
var _decl0_35:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_36:i0.ElementRef<any> = (<any>(null as any));
function _View_ModalComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ModalComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'modal fade ',(_decl0_16.modalOptions.modalClass? _decl0_16.modalOptions.modalClass: ''),
      '');
  currVal_0;
  const currVal_1:any = (<any>{'in':_decl0_16.isOpen});
  currVal_1;
  const currVal_2:any = (<any>{'display':(_decl0_16.isOpen? 'block': 'none'),'z-index':(1050 + (_decl0_16.instanceCount * 10))});
  currVal_2;
  const currVal_3:any = _decl0_16.isOpen;
  currVal_3;
  const currVal_4:any = _decl0_16.instanceCount;
  currVal_4;
  const currVal_5:any = (_decl0_16.modalOptions.backdrop !== false);
  currVal_5;
}
function _View_ModalContentComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ModalContentComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_ModalBackdropComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_ModalBackdropComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'modal-backdrop fade ',(((_decl0_18.modalOptions == null)? (null as any): _decl0_18.modalOptions.backdropClass) || ''),
      '');
  currVal_0;
  const currVal_1:any = (<any>{'in':_decl0_18.isOpen});
  currVal_1;
  const currVal_2:any = (<any>{'z-index':((1040 + (_decl0_18.instanceCount * 10)) + 1)});
  currVal_2;
}
function _View_ModalWindowComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ModalWindowComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'modal-dialog ',(_decl0_19.modalOptions.size? (' modal-' + _decl0_19.modalOptions.size): ''),
      '');
  currVal_0;
}
